import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {FormsModule} from "@angular/forms";
import {AppService} from './services/app.service';
import {HttpClientModule} from "@angular/common/http";
import {SharedComponentsModule} from "./shared-components/shared-components.module";
// import { IonicStorageModule } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';



@NgModule({
    declarations: [AppComponent],
    imports: [BrowserModule,
        HttpClientModule,
        SharedComponentsModule,
        IonicModule.forRoot(),
        IonicStorageModule.forRoot(),
        AppRoutingModule],
    providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, AppService],
    bootstrap: [AppComponent]
})
export class AppModule {}
